import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`posthog.Capture("distinct_id_of_the_user", "user_signed_up");
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`posthog.Capture(
    "distinct_id_of_the_user", 
    "user_signed_up", 
    properties: new() {
        ["login_type"] = "email", 
        ["is_free_trial"] = "true"
    }
);
`}</code></pre>
    <h3 {...{
      "id": "sending-page-views"
    }}>{`Sending page views`}</h3>
    <p>{`If you're aiming for a backend-only implementation of PostHog and won't be capturing events from your frontend, you can send `}<inlineCode parentName="p">{`$pageview`}</inlineCode>{` events from your backend like so:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`using PostHog;
using Microsoft.AspNetCore.Http.Extensions;

posthog.CapturePageView(
    "distinct_id_of_the_user",
    HttpContext.Request.GetDisplayUrl());
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      